import { DELETE_LOT_FILE } from '../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_LOT_FILE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DELETE_LOT_FILE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case DELETE_LOT_FILE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
